import styled from 'styled-components';

export default function AcademyNoContent({ msg }) {
  return <NoContentWrapper>{msg && <h2>{msg}</h2>}</NoContentWrapper>;
}

const NoContentWrapper = styled.div`
  width: 100%;
`;
